import { combineReducers } from '@reduxjs/toolkit'
import {
  externalPageDataReducers,
  externalToolLinkDataReducers,
  fundScreenerSessionDataReducers,
} from '../slices'

export const toolsReducers = combineReducers({
  external: combineReducers({
    link: externalToolLinkDataReducers,
    page: externalPageDataReducers,
  }),
  fundScreener: combineReducers({
    session: fundScreenerSessionDataReducers,
  }),
})
